<template>
	<div class='c-img' :style='containerStyle'>
		<div class='c-img__image' :style='style'></div>
	</div>
</template>

<script>
export default {
	props: {
		src: {
			type:    String,
			default: ''
		},
		ratio: {
			type:    Number,
			default: 1
		}
	},
	computed: {
		style() {
			return {
				backgroundImage: `url(${this.src})`
			};
		},
		containerStyle() {
			return {
				paddingTop: `${100 / this.ratio}%`
			};
		},
	}
};
</script>
